import networkCallWrapper from "hooks/networking/networkCallWrapper";
import { getPlatform } from "utils/platforms";

export type AddBankAccountSuccessResponse = {
    partner_account_id: string
    public_token: string
}

export type AddBankAccountErrorResponse = {
    status: string
    error: string
}

export type AddBankAccountRequestData = AddBankAccountSuccessResponse | AddBankAccountErrorResponse

export async function addBankAccount(data: AddBankAccountRequestData): Promise<boolean> {

    const url = "client_user/bank_account/add/account"
    const method = "POST"
    const service = "userCaas"

    const platform = getPlatform().toString()
    const deviceId = platform + "-user"

    const request = await networkCallWrapper(
        url,
        method,
        service,
        null,
        data,
        undefined,
        {
            'X-Platform': platform,
            'X-Device-Id': deviceId,
            'X-Source': 'sdk',
        }
    );

    return request.success
}